export default {
  crmUsers: {},
  crmTeams: {
    root: [],
  },
  parentTeams: {
    children: [],
  },
  teamMembers: {
    results: [],
  },
  records: {
    results: [],
  },
  dictionaryList: {
    results: [],
  },
  dictionaryDetailList: {
    results: [],
  },
  dictionaryDetail: {
    results: [],
  },
  teamConfigList: {
    results: [],
  },
  secondTeamList: {
    data: [],
  },
  allCategoryList: {
    results: [],
  },
  allDictionaryList: {
    results: [],
  },
  teamConfigDetail: {},
  teamChangeList: [],
  roleList: [],
  roleUserList: [],
  menuTreeList: [],
  productList: [],
};
